module.exports = __webpack_public_path__ + "static/hot_oil-df66676f8fb5aec00bcdda0c35235dca.png";